/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { useRef } from 'react';

import { cssMap, jsx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Text } from '@atlaskit/primitives/compiled/text';
import Tooltip from '@atlaskit/tooltip/Tooltip';

const styles = cssMap({
	container: {
		width: '100%',
	},
});

export const IssueTextNode: ({ text }: { text: string | null }) => JSX.Element = ({
	text,
}: {
	text: string | null;
}) => {
	const textRef = useRef<HTMLSpanElement | null>(null);
	if (!text) {
		return <Text>&nbsp;</Text>;
	}

	return (
		<Tooltip
			content={text}
			// don't need a screen reader announcement as the
			// tooltip content is the same as the items content
			isScreenReaderAnnouncementDisabled
			canAppear={() => {
				const element = textRef.current;

				// Only showing the tooltip for this item when
				// the element has been clamped.
				return !!element && element.scrollHeight > element.clientHeight;
			}}
		>
			{(props) => (
				<Box {...props} xcss={styles.container}>
					<Text ref={textRef} maxLines={1}>
						{text}
					</Text>
				</Box>
			)}
		</Tooltip>
	);
};
